import { NodeViewWrapper } from "@tiptap/react";
import { useRef } from "react";
import { AlignLeft, AlignCenter, AlignRight } from "lucide-react";

const alignStyle = (align) => {
  if (align === "left") return { float: "left", margin: "0.25rem 1.25rem 0.5rem 0" };
  if (align === "right") return { float: "right", margin: "0.5rem 0 0.5rem 1.25rem" };
  return { display: "table", margin: "1rem auto", clear: "both" };
};

export default function ResizableImageView({ node, updateAttributes, selected, editor }) {
  const { src, alt, width, align } = node.attrs;
  const imgRef = useRef(null);

  const startResize = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const startX = e.clientX;
    const startW = imgRef.current?.offsetWidth || 200;
    const max = editor.view.dom.clientWidth;
    const onMove = (ev) => {
      let w = Math.max(60, startW + (ev.clientX - startX));
      if (w > max) w = max;
      updateAttributes({ width: Math.round(w) + "px" });
    };
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  };

  const setAlign = (e, a) => {
    e.preventDefault();
    e.stopPropagation();
    updateAttributes({ align: a });
  };

  return (
    <NodeViewWrapper
      className="ri-wrapper"
      data-align={align}
      style={{ position: "relative", maxWidth: "100%", width: width || undefined, ...alignStyle(align) }}
    >
      <img
        ref={imgRef}
        src={src}
        alt={alt || ""}
        draggable={false}
        style={{ display: "block", width: width ? "100%" : "auto", maxWidth: "100%", height: "auto", outline: selected ? "2px solid #141414" : "none" }}
      />
      {selected && (
        <div className="ri-toolbar" contentEditable={false}>
          <button type="button" title="Izquierda (texto a la derecha)" onMouseDown={(e) => setAlign(e, "left")} data-testid="ri-align-left"><AlignLeft size={14} /></button>
          <button type="button" title="Centrar" onMouseDown={(e) => setAlign(e, "center")} data-testid="ri-align-center"><AlignCenter size={14} /></button>
          <button type="button" title="Derecha (texto a la izquierda)" onMouseDown={(e) => setAlign(e, "right")} data-testid="ri-align-right"><AlignRight size={14} /></button>
        </div>
      )}
      {selected && <span className="ri-handle" onMouseDown={startResize} contentEditable={false} data-testid="ri-resize-handle" />}
    </NodeViewWrapper>
  );
}
